import { render } from "./ArticleCollection.vue?vue&type=template&id=08b862fb&scoped=true"
import script from "./ArticleCollection.vue?vue&type=script&lang=js"
export * from "./ArticleCollection.vue?vue&type=script&lang=js"

import "./ArticleCollection.scss?vue&type=style&index=0&id=08b862fb&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b862fb"]])

export default __exports__